<template>
    <div class="row">
         <ul class="collapsible">
            <li>
                <div  class="collapsible-header">
                    <slot name="collapsible-header">
                    </slot>
                    
                </div>
                <div class="collapsible-body">
                    <slot name="collapsible-body">
                        
                    </slot>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name:'BaseCollapsible',
    props:{
        items:[]
    },
    mounted(){
        $(document).ready(function(){
            $('.collapsible').collapsible();
        });
    }
}
</script>